import { sharedAtlantikiFields } from '@/views/checkouts/companies/Atlantiki/shared/sharedAtlantikiSchema';
import * as yup from 'yup';

export const CarAtlantikiSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedAtlantikiFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
    seats: yup.number().required().integer().min(1),
    color: yup.string().required(),
  });
};

export default CarAtlantikiSchemaBuilder;
